
import React from 'react';
import { PatientInsuranceEditModalTemplate } from 'themes/application/facility-order/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { PatientInsuranceEditModalViewStore } from 'application/facility-order/stores';

@setCurrentView((rootStore, componentProps) => new PatientInsuranceEditModalViewStore(rootStore, componentProps), 'patientInsuranceEditModalViewStore')
@observer
class PatientInsuranceEditModal extends React.Component {
    render() {
        return <PatientInsuranceEditModalTemplate {...this.props} />
    }
}

export default PatientInsuranceEditModal;
